import React from 'react';
import {
    Home, Target, MessageSquare, Upload, Brain,
    X, Link2, ClipboardList
} from 'lucide-react';

const Sidebar = ({
    activeTab,
    setActiveTab,
    isSidebarOpen,
    setIsSidebarOpen
}) => {
    const navigationItems = [
        { id: 'dashboard', label: 'Dashboard', icon: Home },
        { id: 'knowledgeCapture', label: 'Knowledge capture', icon: ClipboardList },
        { id: 'tasks', label: 'Task manager', icon: Target },
        { id: 'chat', label: 'Knowledge search', icon: MessageSquare },
        { id: 'documents', label: 'Documents', icon: Upload },
        { id: 'brain', label: 'Brain', icon: Brain },
        { id: 'integrations', label: 'Integrations', icon: Link2 }
    ];

    return (
        <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-white/90 backdrop-blur-xl border-r border-gray-200/50 transform transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:relative lg:translate-x-0 lg:inset-0 flex-shrink-0`}>
            <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200/50">
                <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-gradient-to-br from-slate-700 to-slate-900 rounded-lg flex items-center justify-center">
                        <Brain className="w-5 h-5 text-white" />
                    </div>
                    <div>
                        <h1 className="text-lg font-bold text-slate-900">DendriteAI</h1>
                    </div>
                </div>
                <button
                    onClick={() => setIsSidebarOpen(false)}
                    className="lg:hidden p-1.5 rounded-lg hover:bg-gray-100 transition-colors"
                >
                    <X className="w-5 h-5 text-gray-500" />
                </button>
            </div>

            <nav className="mt-6 px-3 flex-1 overflow-y-auto">
                <div className="space-y-1">
                    {navigationItems.map(({ id, label, icon: Icon }) => (
                        <button
                            key={id}
                            onClick={() => {
                                setActiveTab(id);
                                setIsSidebarOpen(false);
                            }}
                            className={`w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-xl transition-all duration-200 ${activeTab === id
                                ? 'bg-slate-800 text-white shadow-lg'
                                : 'text-slate-700 hover:text-slate-900 hover:bg-slate-50'
                                }`}
                        >
                            <Icon className="w-5 h-5 mr-3" />
                            {label}
                        </button>
                    ))}
                </div>
            </nav>
        </div>
    );
};

export default Sidebar;
